function topMainvisualEffect(){
	var ary = [
		'top',
		'debug',
		'localize',
		'illust',
		'promo',
		'print'
	];

	var n;

	var setRandom = setInterval(function(){
		var rand = Math.floor( Math.random() * 6);


		if(rand == n && rand <5){
			n = rand + 1;
		}else if(rand == n  && rand == 5){
			n = 0;
		}else{
			n = rand;
		}


		var i = n + 1;

		if(n == 0){
			var link = '';
		}else{
			var link = '/service/' + ary[n];
		}

		$('.mt__icon--' + ary[n]).addClass('is--mouseover');
		$('.mt__balloon--' + ary[n]).addClass('is--mouseover');
		$('.mt__airship__link').attr('href', link);
		$('.mt__airship__link').removeAttr('style');
		if(ary[n] == 'top'){
			$('.mt__airship__link').css({
				'cursor' : 'default',
				'pointer-events' : 'none'
			});
		}
		//$('.mt__airship ul').attr('class','is--' + ary[n]);
		$('.mt__airship ul li:nth-of-type(' + i + ')').addClass('is--visible').siblings().removeClass('is--visible');
		setTimeout(function(){
			$('.mt__icon--' + ary[n]).removeClass('is--mouseover')
			$('.mt__balloon--' + ary[n]).removeClass('is--mouseover')
		},3000)
	},4000);
	$(document).on('mouseover', '.mt__link', function(){
		clearInterval(setRandom);
		$(this).next('img').addClass('is--mouseover');
		$(this).next('img').next('img').addClass('is--mouseover');
		var service = $(this)[0].getAttribute('data-service');
		var n = ary.indexOf(service) + 1;
		$('.mt__airship__link').attr('href', '/service/' + service);
		$('.mt__airship ul li:nth-of-type(' + n + ')').addClass('is--visible').siblings().removeClass('is--visible');
	});
	$(document).on('mouseout', '.mt__link', function(){
		$(this).next('img').removeClass('is--mouseover');
		$(this).next('img').next('img').removeClass('is--mouseover');
		setRandom = setInterval(function(){
			var rand = Math.floor( Math.random() * 6);


			if(rand == n && rand <5){
				n = rand + 1;
			}else if(rand == n  && rand == 5){
				n = 0;
			}else{
				n = rand;
			}

			var i = n + 1;

			if(n == 0){
				var link = '';
			}else{
				var link = '/service/' + ary[n];
			}

			$('.mt__icon--' + ary[n]).addClass('is--mouseover');
			$('.mt__balloon--' + ary[n]).addClass('is--mouseover');
			$('.mt__airship__link').attr('href', link);
			$('.mt__airship__link').removeAttr('style');
			if(ary[n] == 'top'){
				$('.mt__airship__link').css({
					'cursor' : 'default',
					'pointer-events' : 'none'
				});
			}
			//$('.mt__airship ul').attr('class','is--' + ary[n]);
			$('.mt__airship ul li:nth-of-type(' + i + ')').addClass('is--visible').siblings().removeClass('is--visible');
			setTimeout(function(){
				$('.mt__icon--' + ary[n]).removeClass('is--mouseover')
				$('.mt__balloon--' + ary[n]).removeClass('is--mouseover')
			},3000)
		},4000);
	});
}

module.exports = topMainvisualEffect;



// WEBPACK FOOTER //
// ./es2015/_top_mainvisual_effect.js